export default "__VITE_PUBLIC_ASSET__40a5c96b__"